export const ACTION = { CREATE: "CREATE", EDIT: "EDIT", CLONE_PRODUCT: "CLONE_PRODUCT" };

export const ATTRIBUTE_TYPE = { PREDEFINED: "PREDEFINED", FREE_TEXT: "FREE_TEXT" };

export const PRODUCT_INPUT_TYPE = {
  UPLOAD_IMAGE: "UPLOAD_IMAGE",
  INPUT_NUMBER: "INPUT_NUMBER",
  SELECT: "SELECT",
  INPUT_CURRENCY: "INPUT_CURRENCY",
  INPUT_SHORT_CODE: "INPUT_SHORT_CODE",
  INPUT_PRODUCT_CODE: "INPUT_PRODUCT_CODE",
  INPUT_VAT: "INPUT_VAT",
  VAT_PERCENT_TYPE: "VAT_PERCENT_TYPE",
};

export const PRODUCT_TYPE = {
  MATERIAL: "MATERIAL",
  KEY_LICENSE: "KEY_LICENSE",
};

//preset options for "Loại % VAT" — "OTHER" lets user type a custom percent
export const OPTION_VAT_PERCENT = [
  { value: 8, label: "8%" },
  { value: 10, label: "10%" },
  { value: 0, label: "0%" },
  { value: 3, label: "3%" },
  { value: 5, label: "5%" },
  { value: -1, label: "KCT" },
  { value: "OTHER", label: "Khác" },
];

export const isPresetVatPercent = (value) => [-1, 0, 3, 5, 8, 10].includes(value);

export const MAX_PRODUCT_IMAGES = 9;
export const MAX_VARIANT_IMAGES = 9;
